class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
    if (typeof initUpsellSlider === "function") { 
      initUpsellSlider()
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }));
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


document.addEventListener("DOMContentLoaded", function () {
  // Function to initialize the cart and button event listeners
  function initializeCartFunctionality() {

    // Attach event listeners to "Add to Cart" buttons on the collection page
    document
      .querySelectorAll(".product-variant-submit-button")
      .forEach(function (button) {
        // Prevent the delayed initializers below from attaching the same
        // add-to-cart handler more than once to a product card.
        if (button.dataset.magicCartHandlerBound === "true") return;
        button.dataset.magicCartHandlerBound = "true";

        button.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent default form submission

          // Prevent rapid double clicks while the selected variant is added.
          if (this.dataset.magicCartRequestPending === "true") return;
          this.dataset.magicCartRequestPending = "true";

          var form = this.closest("form"); // Get the parent form
          var formData = new FormData(form); // Prepare form data for submission

          // Perform AJAX request to add the product to the cart
          fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => response.json())
            .then((data) => {
              // Open cart drawer by simulating a click on the cart icon
              document.getElementById("cart-icon-bubble").click();

              // Remove 'is-empty' class and hide the empty cart drawer elements
              var cartDrawer = document.querySelector(".drawer");
              if (cartDrawer) {
                cartDrawer.classList.remove("is-empty");
              }
              var emptyCartMessage = document.querySelector(
                ".drawer__inner-empty"
              );
              if (emptyCartMessage) {
                emptyCartMessage.style.display = "none";
              }

              // Now fetch and update the cart drawer contents
              updateCartDrawerContent();
            })
            .catch((error) => {
              console.error("Error adding product to cart:", error);
            })
            .finally(() => {
              button.dataset.magicCartRequestPending = "false";
            });
        });
      });
  }

  // Function to fetch and update the cart drawer content
  function updateCartDrawerContent() {
    fetch("/cart?view=drawer") // Assuming you have a cart drawer view
      .then((response) => response.text())
      .then((html) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var newCartDrawer = doc.querySelector("#CartDrawer").innerHTML;
        document.querySelector("#CartDrawer").innerHTML = newCartDrawer;

        // Re-bind any necessary events after updating the cart drawer
        bindCartEvents();
      })
      .catch((error) => {
        console.error("Error fetching updated cart drawer content:", error);
      });
  }

  // Function to bind events like removing items, updating quantities, etc.
  function bindCartEvents() {
    // Add any necessary event listeners for cart functionality here
  }

  // Run the cart initialization function immediately
  initializeCartFunctionality();

  // Schedule the function to run again after 4 seconds and 7 seconds
  setTimeout(() => {
    initializeCartFunctionality(); // Run the function again after 4 seconds

    setTimeout(() => {
      initializeCartFunctionality(); // Run the function one last time after 7 seconds
    }, 3000); // 3 seconds after the 4-second mark (total of 7 seconds)
  }, 4000); // First delay of 4 seconds
});


// -------------- Cart Discount coupon




const cartDrawer = document.querySelector('cart-drawer');
const cartIcon = document.getElementById('cart-icon-bubble'); 

// Store discount input and message state globally
let discountInputValue = '';
let discountErrorMessage = '';

// Create a MutationObserver to detect changes within the cart drawer content
const cartContentObserver = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList') {
      initializeDiscountFunctionality(); // Reinitialize discount functionality
    }
  });
});

// Start observing the cart drawer content for any changes
cartContentObserver.observe(cartDrawer, { childList: true, subtree: true });

// Listen for the cart icon click to ensure discount functionality works
cartIcon.addEventListener('click', () => {
  initializeDiscountFunctionality();
});

// Function to initialize the discount functionality
function initializeDiscountFunctionality() {

  const discountInput = document.getElementById('discount-code');
  const discountMessage = document.getElementById('discount-message');
  const discountButton = document.getElementById('apply-discount-btn');

  // Restore the previous input value and error message
  if (discountInput) discountInput.value = discountInputValue;
  if (discountMessage) {
    discountMessage.style.display = discountErrorMessage ? 'block' : 'none';
    discountMessage.textContent = discountErrorMessage;
  }

  // Ensure the discount button exists and bind the click event
  if (discountButton) {

    // Remove previous event listener to avoid duplicates
    discountButton.removeEventListener('click', handleDiscountCode);

    // Bind the click event listener
    discountButton.addEventListener('click', handleDiscountCode);
  } else {
    console.error("Discount button not found. Retrying...");

    // Retry initialization after 2 seconds if the button wasn't found
    setTimeout(() => {
      initializeDiscountFunctionality();
    }, 2000);
  }
}

// Function to handle discount code logic
function handleDiscountCode() {

  const discountInput = document.getElementById('discount-code');
  const discountMessage = document.getElementById('discount-message');
  const discountButton = document.getElementById('apply-discount-btn');
  const discountCode = discountInput?.value.trim();

  // Save the current input value globally
  discountInputValue = discountCode;

  // Validate the input to ensure the discount code is not empty
  if (!discountCode) {
    discountErrorMessage = "Veuillez entrer un code promo.";
    discountMessage.style.display = 'block';
    discountMessage.style.color = 'red';
    discountMessage.textContent = discountErrorMessage;
    return;
  }

  // Add loading state to the button
  discountButton.classList.add('button-loading');
  discountButton.disabled = true;

  // Apply the discount code using Shopify's discount endpoint
  fetch(`/discount/${discountCode}`, { method: 'GET' })
    .then(async (response) => {
      const cart = await fetch('/cart.js').then((res) => res.json());

      if (response.ok && cart.cart_level_discount_applications.length > 0) {
        discountErrorMessage = "Code promo appliqué avec succès!";
    discountMessage.style.color = 'green';
        
      } else {
    discountMessage.style.color = 'red';
        discountErrorMessage = "Code promo invalide.";
      }

      // Update the message
      discountMessage.style.display = 'block';
      discountMessage.textContent = discountErrorMessage;

      // Refresh the cart drawer
      setTimeout(() => {
        updateCartDrawerContent();
      }, 1000);
    })
    .catch((error) => {
      console.error("Erreur lors de l'application du code promo:", error);
      discountErrorMessage = "Une erreur s'est produite. Veuillez réessayer.";
      discountMessage.style.display = 'block';
      discountMessage.textContent = discountErrorMessage;
    })
    .finally(() => {
      // Remove loading state from the button
      discountButton.classList.remove('button-loading');
      discountButton.disabled = false;
    });
}

// Function to update the cart drawer content dynamically
function updateCartDrawerContent() {
  fetch("/cart?view=drawer") // Fetch the updated cart drawer view
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartDrawer = doc.querySelector("#CartDrawer").innerHTML;
      document.querySelector("#CartDrawer").innerHTML = newCartDrawer;


      // Re-bind necessary events after the cart drawer is updated
      bindCartEvents();

      // Reinitialize the discount functionality after updating the cart drawer
      initializeDiscountFunctionality();
    })
    .catch((error) => {
      console.error("Error fetching updated cart drawer content:", error);
    });
}

// Function to bind necessary cart events after the drawer is updated
function bindCartEvents() {

  document.querySelectorAll('.remove-item').forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
    });
  });

  // Detect cart updates by product addition or quantity change
  document.querySelectorAll('.quantity-update').forEach((input) => {
    input.addEventListener('change', function () {
      updateCartDrawerContent(); // Refresh the cart drawer on quantity change
    });
  });
}
// -------------- End of Cart Discount coupon
